import * as React from "react";

export class FileSelector extends React.Component<{ clearOnSelect?: boolean, handleFileChange: (files: File | null) => void, label?: string }, {}>
{
    fileUpload: null | HTMLInputElement = null

    handleFileChange = (fileList: FileList) => {
        if (this.fileUpload && this.fileUpload.files)
            this.props.handleFileChange(this.fileUpload.files[0])
        if (this.props.clearOnSelect && this.fileUpload) this.fileUpload.value = "";
    }

    render() {
        return <div>
            {this.props.label ? <label>{this.props.label}</label> : null}
            <input ref={(ref) => this.fileUpload = ref} className="form-control-file" type="file" onChange={(e: any) => this.handleFileChange(e.target.files)} />
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/shared/FileSelector.tsx